import { supabase } from "@/integrations/supabase/client";

const VAPID_PUBLIC_KEY = "BMmqODckxHYmoJEs1jY5GQ0Qpr-r7q2W0TI5qk10q2DbF9urYm05g-SiYAudcxAAuIZH9sxdIUKb5n4ccMj6aws";

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function arrayBufferToBase64Url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export async function subscribeToPush(userId: string): Promise<boolean> {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.log("[Push] Not supported");
      return false;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("[Push] Permission denied");
      return false;
    }

    const registration = await navigator.serviceWorker.ready;
    
    // Check existing subscription
    let subscription = await registration.pushManager.getSubscription();
    
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY).buffer as ArrayBuffer,
      });
    }

    const key = subscription.getKey("p256dh");
    const auth = subscription.getKey("auth");
    if (!key || !auth) {
      console.error("[Push] Missing keys");
      return false;
    }

    const p256dh = arrayBufferToBase64Url(key);
    const authToken = arrayBufferToBase64Url(auth);

    // Upsert subscription
    const { error } = await supabase.from("push_subscriptions").upsert(
      {
        user_id: userId,
        endpoint: subscription.endpoint,
        p256dh: p256dh,
        auth: authToken,
      },
      { onConflict: "user_id,endpoint" }
    );

    if (error) {
      console.error("[Push] Save error:", error);
      return false;
    }

    console.log("[Push] Subscribed successfully");
    return true;
  } catch (err) {
    console.error("[Push] Subscribe error:", err);
    return false;
  }
}

export async function sendPushToUser(userId: string, title: string, body: string, url?: string) {
  try {
    await supabase.functions.invoke("send-push", {
      body: { user_id: userId, title, body, url },
    });
  } catch (err) {
    console.error("[Push] Send error:", err);
  }
}
